import { Ref } from "react";

import { css, type CSSProperties } from "@compiled/react";

import CrossIcon from "@atlaskit/icon/glyph/cross";
import { token } from "@atlaskit/tokens";

import { useMessages } from "../state";

const closeModalButtonStyles = css({
    width: "30px",
    height: "30px",
    backgroundColor: "transparent",
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: token("border.radius", "3px"),
    cursor: "pointer",
    transition: "200ms",
    // Visual hack to match styles while focus is manually updated throughout demo
    ["&:disabled"]: {
        color: token("color.icon.disabled", "#091E424F")
    },
    ["&:hover, &:focus"]: {
        backgroundColor: token("color.interaction.hovered", "#00000029")
    }
});

export const CloseModalButton = ({
    forwardRef,
    onCloseClick,
    styleOverrides
}: {
    forwardRef?: Ref<HTMLButtonElement>;
    onCloseClick: () => void | Promise<void>;
    styleOverrides?: CSSProperties;
}) => {
    const [messages] = useMessages();

    return (
        <button
            data-testid="closeModalBtn"
            aria-label={messages.createIssueModalCloseBtn}
            css={closeModalButtonStyles}
            // @ts-ignore
            style={styleOverrides}
            id="createIssueModalCloseBtn"
            onClick={onCloseClick}
            ref={forwardRef}
        >
            <CrossIcon label="" size="medium" />
        </button>
    );
};
